import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, getTrackByFn } from '@y42/angular/util';
import { isNotNullish } from '@y42/util/nullish';
import { filter, map, tap } from 'rxjs';
import { GoJsContextMenuItem } from './gojs-context-menu.model';
import { GojsContextMenuService } from './gojs-context-menu.service';

@UntilDestroy()
@Component({
  selector: 'y42-gojs-context-menu',
  templateUrl: './gojs-context-menu.component.html',
  styleUrls: ['./gojs-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GojsContextMenuComponent {
  constructor(private readonly contextMenuService: GojsContextMenuService) {}

  @ViewChild('menuTrigger') menuTrigger?: MatMenuTrigger;

  readonly trackByLabel = getTrackByFn<GoJsContextMenuItem>('label');

  public readonly state = connectState(this, {
    model: this.contextMenuService.contextMenu$.pipe(
      filter((model) => isNotNullish(model)),
      tap(({ open }) =>
        requestAnimationFrame(() => (open ? this.menuTrigger?.openMenu() : this.menuTrigger?.closeMenu())),
      ),
      map(({ options }) => ({
        items: options?.items || [],
        position: options?.position || { x: 0, y: 0 },
      })),
    ),
  });
}
